import { AppError } from '../errors'

const transientCodes = new Set(['429', '502', '503', '504'])

export function classifySyncError(error: unknown): 'TRANSIENT' | 'AUTH' | 'CONFLICT' | 'PERMANENT' {
  if (error instanceof AppError) {
    if (error.code === 'CONNECTION') return 'TRANSIENT'
    if (error.code === 'AUTH') return 'AUTH'
    if (error.code === 'CONFLICT') return 'CONFLICT'
    return 'PERMANENT'
  }
  const text = error instanceof Error ? error.message : String(error)
  if (/429|5\d\d|timeout|network|fetch|abort/i.test(text) || [...transientCodes].some((code) => text.includes(code))) return 'TRANSIENT'
  if (/jwt|session|token|auth/i.test(text)) return 'AUTH'
  if (/conflito|conflict|vers[aã]o/i.test(text)) return 'CONFLICT'
  return 'PERMANENT'
}

export function retryDelayMs(attempt: number): number {
  return [1_000, 2_000, 5_000, 10_000, 30_000][Math.min(Math.max(attempt - 1, 0), 4)] ?? 30_000
}

